// extracted by mini-css-extract-plugin
export default {"btn":"manage-forms_btn__sbdnY","btn-flex":"manage-forms_btn-flex__murbn","save":"manage-forms_save__4mm7p","cancel":"manage-forms_cancel__IpPni"};